module.exports = __webpack_public_path__ + "static/media/review.4a404422.svg";